import ReactDOM from 'react-dom/client';
import { App } from './components/app';

const appContainter = document.getElementById('app');
const app = ReactDOM.createRoot(appContainter);
app.render(<App />);
